import React, { useEffect } from "react";

const InAppViewer = ({ filename, onClose }) => {
  const token = localStorage.getItem("token");
  const base = process.env.REACT_APP_API_URL || "http://localhost:5000";
  const isPdf = /\.pdf$/i.test(filename);
  const src = `${base}/view-file/${encodeURIComponent(filename)}?token=${encodeURIComponent(token || "")}`;

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.box} onClick={(e) => e.stopPropagation()}>
        <div style={styles.head}>
          <span style={styles.title}>
            <span style={{ color: "#34d399", marginRight: 8 }}>📄</span>
            Ijyipande cy'Amavuko
          </span>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div style={styles.content}>
          {isPdf ? (
            <iframe
              src={src}
              title="Ijyipande cy'Amavuko"
              style={{ width: "100%", height: "100%", border: "none", borderRadius: 6 }}
            />
          ) : (
            <img
              src={src}
              alt="Ijyipande cy'Amavuko"
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 8 }}
              onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "block"; }}
            />
          )}
          <p style={{ display: "none", color: "#f87171", fontSize: "0.9rem" }}>
            Ntibishobotse gufungura dosiye.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed", inset: 0,
    background: "rgba(0,0,0,0.88)",
    backdropFilter: "blur(8px)",
    zIndex: 3000,
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: 14,
  },
  box: {
    background: "rgba(10,10,22,0.98)",
    border: "1px solid rgba(255,255,255,0.07)",
    borderRadius: 18,
    width: "100%", maxWidth: 860,
    height: "min(88vh, 700px)",
    display: "flex", flexDirection: "column",
    overflow: "hidden",
    boxShadow: "0 24px 80px rgba(0,0,0,0.7)",
  },
  head: {
    padding: "14px 18px",
    borderBottom: "1px solid rgba(255,255,255,0.05)",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    flexShrink: 0,
  },
  title: { fontSize: "0.9rem", fontWeight: 700, color: "#fff" },
  content: {
    flex: 1, overflow: "auto", display: "flex",
    alignItems: "center", justifyContent: "center",
    flexDirection: "column",
    background: "rgba(5,5,12,0.6)", padding: 16,
  },
  closeBtn: {
    width: 34, height: 34, borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.07)",
    background: "rgba(255,255,255,0.02)",
    color: "rgba(255,255,255,0.5)",
    cursor: "pointer", fontSize: "0.95rem",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
};

export default InAppViewer;
